// extracted by mini-css-extract-plugin
export default {"cls1":"im5RESeC1p858byJJvU1","cls2":"bOI14rT7XwG_j7QyaVOc im5RESeC1p858byJJvU1"};